import type { ApiAreaOfFocus } from '#/api/types/ApiAreaOfFocus';
import type { ApiVolopFunction } from '#/api/types/ApiVolopFunction';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchAlgoliaOptionsWithSearchLocation } from '#/modules/search/algolia/options/searchAlgoliaOptionsWithSearchLocation';
import { searchAlgoliaConfig } from '#/modules/search/algolia/searchAlgoliaConfig';
import { searchAlgoliaVolopsIndex } from '#/modules/search/algolia/searchAlgoliaVolopsIndex';
import type { SearchAlgoliaRecommendedListingHit } from '#/modules/search/algolia/types/SearchAlgoliaRecommendedListingHit';
import type { SearchLocation } from '#/modules/search/types/SearchLocation';
import { algoliaSearch } from '#/utils/algolia/algoliaSearch';

export async function searchAlgoliaFetchRecommendedVolops(
  searchLocation: Pick<SearchLocation, 'latitude' | 'longitude'>,
  queryOptions?: { distinct: boolean },
  options?: {
    volopFunction?: ApiVolopFunction | null | undefined;
    areaOfFocus?: ApiAreaOfFocus | null | undefined;
    locale?: I18nLocale | 'all';
  },
) {
  return algoliaSearch<SearchAlgoliaRecommendedListingHit>({
    config: searchAlgoliaConfig(),
    query: '',
    indexName: searchAlgoliaVolopsIndex({
      sort: 'newest',
    }),
    options: searchAlgoliaOptionsWithSearchLocation({
      options: {
        filters: [
          'actionType:VOLOP',
          'source:IDEALIST',
          options?.volopFunction && `(functions:'${options.volopFunction}')`,
          options?.areaOfFocus && `(areasOfFocus: '${options.areaOfFocus}')`,
          options?.locale &&
            options.locale !== 'all' &&
            `(locale: '${options.locale}')`,
        ]
          .filter(Boolean)
          .join(' AND '),
        hitsPerPage: 20,
        attributesToRetrieve: [
          'objectID',
          'name',
          'city',
          'state',
          'logo',
          'orgName',
          'url',
        ],
        distinct: queryOptions?.distinct,
      },
      searchLocation,
      radius: '',
    }),
  }).then(({ hits }) => hits);
}
